/** Admin: create a prepaid wash bundle for one owner (owner-twin). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../src/context/OwnerScopeContext';
import AddBundleScreen from '../../../../owner/subscriptions/add-bundle';

export default function AdminOwnerAddBundleScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <AddBundleScreen />
    </OwnerScopeProvider>
  );
}
